import { getApi, postApi, putApi, deleteApi } from "../base.api.js";

// Get all users
export const getAllUsers = async () => {
    const response = await getApi('admin/users');
    console.log('Get all users response:', response);
    return response;
};

// Get single user
export const getUserById = async (userId) => {
    const response = await getApi(`admin/users/${userId}`);
    console.log('Get user response:', response);
    return response;
};

// Create new user
export const createUser = async (userData) => {
    const response = await postApi('admin/users', userData);
    console.log('Create user response:', response);
    return response;
};

// Update user
export const updateUser = async (userId, userData) => {
    const response = await putApi(`admin/users/${userId}`, userData);
    console.log('Update user response:', response);
    return response;
};

// Delete user
export const deleteUser = async (userId) => {
    const response = await deleteApi(`admin/users/${userId}`);
    console.log('Delete user response:', response);
    return response;
};

// Get user statistics
export const getUserStats = async () => {
    const response = await getApi('admin/users/stats');
    console.log('Get user stats response:', response);
    return response;
};

// Get available roles
export const getAvailableRoles = async () => {
    const response = await getApi('admin/roles');
    console.log('Get roles response:', response);
    return response;
};